// Endpoint specs:
// https://www.dropbox.com/scl/fi/31nxogj0nap0jy842z4sg/Payment-Page.paper?dl=0&rlkey=sx4z963m428xpb3tpar5sb92y#:uid=259258728448306139937439&h2=Endpoint:-Make-a-payment

// // ERROR RESPONSE
// export const mockSubmitPaymentResponse = {
//   userID: 11167815,
//   isApp: false,
//   success: false,
//   errorCode: "general",
// };

// // ERROR RESPONSE: Modify Payment → payment already processed
// export const mockSubmitPaymentResponse = {
//   success: false,
//   isApp: false,
//   error: "already_processed",
//   message: "already_processed",
//   userID: 11167815,
// };

// // SUCCESS RESPONSE
export const mockSubmitPaymentResponse = {
  userID: 11167815,
  isApp: false,
  success: true,
  paymentID: 1234,
};
